var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDocumentLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.37891 3.2166C2.37891 2.55386 2.91616 2.0166 3.57891 2.0166H9.08185C9.40011 2.0166 9.70533 2.14303 9.93038 2.36807L13.2274 5.66513C13.4525 5.89017 13.5789 6.1954 13.5789 6.51366V13.6166C13.5789 14.2793 13.0416 14.8166 12.3789 14.8166H3.57891C2.91616 14.8166 2.37891 14.2793 2.37891 13.6166V3.2166ZM4.74976 11.9165C4.74974 11.5023 5.08551 11.1665 5.49972 11.1665L7.99972 11.1666C8.41393 11.1666 8.74974 11.5024 8.74976 11.9166C8.74977 12.3309 8.414 12.6666 7.99979 12.6666L5.49979 12.6665C5.08558 12.6665 4.74977 12.3307 4.74976 11.9165ZM5.49972 8.6665C5.08551 8.66649 4.74974 9.00226 4.74976 9.41647C4.74977 9.83068 5.08558 10.1665 5.49979 10.1665L10.4998 10.1667C10.914 10.1667 11.2498 9.83097 11.2498 9.41676C11.2497 9.00255 10.9139 8.66675 10.4997 8.66673L5.49972 8.6665Z",
    fill: "#626B7F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocumentLine);
export default __webpack_public_path__ + "static/media/icon-document-line.5e1dba0f5f33c8d1e82a9fa717732b0f.svg";
export { ForwardRef as ReactComponent };